import { ARTEFACT_META } from '../constants';
import { ArtefactType, CaseArtefact } from '../types';

export function getArtefactMeta(type: ArtefactType) {
  return ARTEFACT_META[type];
}

export function sortArtefacts(artefacts: CaseArtefact[]): CaseArtefact[] {
  return [...artefacts].sort(
    (a, b) =>
      (ARTEFACT_META[a.artefactType]?.order ?? 99) - (ARTEFACT_META[b.artefactType]?.order ?? 99),
  );
}

export function stripMarkdown(text: string): string {
  return text
    .replace(/#{1,6}\s+/g, '')
    .replace(/\*{1,3}(.*?)\*{1,3}/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/`{1,3}[^`]*`{1,3}/g, '')
    .replace(/^\s*[-*+]\s+/gm, '')
    .replace(/^\s*\d+\.\s+/gm, '')
    .replace(/\n{2,}/g, ' ')
    .replace(/\n/g, ' ')
    .trim();
}
